var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 4.33398L8.0013 8.16732L12.3346 4.33398M4.5013 12.1673H11.5013C12.2377 12.1673 12.8346 11.5704 12.8346 10.834V5.16732C12.8346 4.43094 12.2377 3.83398 11.5013 3.83398H4.5013C3.76492 3.83398 3.16797 4.43094 3.16797 5.16732V10.834C3.16797 11.5704 3.76492 12.1673 4.5013 12.1673Z",
    stroke: "#8A8AA3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.80dd94c5a3a8897fad7561ea78c631fa.svg";
export { ForwardRef as ReactComponent };